import React, { Component } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import "../Style.scss";
import "./Style.scss";
import ODIN_Base from "../../../Assets/Softwares/ODIN_Client_BASE-SETUP.exe";
import ODIN_Patch from "../../../Assets/Softwares/ODIN_Patch.exe";
import ODIN_Client_Setup_Guide from "../../../Assets/Softwares/ODIN-Client-Setup-Guide.docx";

export class Downloads extends Component {
  render() {
    return (
      <>
        <Helmet>
          <title>Downloads ~ Algoquant Global</title>
        </Helmet>
        <div className="wrapper downloadsContainer">
          <div className="downloadsHeader container headerforall">
            <div className="leftHeader">
              <h1>DOWNLOADS</h1>
            </div>
            <div className="rightHeader">
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a href="/" className="inActive">
                      Home
                    </a>
                  </li>
                  <li class="breadcrumb-item active" aria-current="page">
                    Downloads
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          <hr width="100%" />
          <Container className="downloads paragraphforall">
            <h3>Softwares</h3>
            <Row>
              <Col>
                <a href={ODIN_Base}>
                  <div className="downloadsCard">
                    <p className="date">01-Mar-2021</p>
                    <h6 className="name">ODIN Base Setup</h6>
                    <div className="animateSpan">
                      <i className="fas fa-download"></i> <span>Download</span>
                    </div>
                  </div>
                </a>
              </Col>
              <Col>
                <a href={ODIN_Patch}>
                  <div className="downloadsCard">
                    <p className="date">01-Mar-2021</p>
                    <h6 className="name">ODIN_Patch</h6>
                    <div className="animateSpan">
                      <i className="fas fa-download"></i> <span>Download</span>
                    </div>
                  </div>
                </a>
              </Col>
              <Col>
                <a href={ODIN_Client_Setup_Guide}>
                  <div className="downloadsCard">
                    <p className="date">15-Mar-2021</p>
                    <h6 className="name">ODINClient - Setup Guide.docx</h6>
                    <div className="animateSpan">
                      <i className="fas fa-download"></i> <span>Download</span>
                    </div>
                  </div>
                </a>
              </Col>
            </Row>
          </Container>
        </div>
      </>
    );
  }
}
export default Downloads;
